import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { Card, CardMedia, CardContent, Typography, Box } from '@mui/material';
import * as React from 'react';
import { useEffect } from 'react';
import { makeStyles } from '@material-ui/core';
import { fetchLearningTools, getLearningTools } from '../../redux/actions/content';
import { useDispatch, useSelector } from 'react-redux';
import {Colors, ResourcePlacement, ResourceStatus, GroupStatus} from '../../enums/enums';
import { fetchUserGroups, getUserGroups } from '../../redux/actions/groups';

const useStyles = makeStyles({
  root: {
    width: '340px',
    height: '270px',
    marginBottom: '30px',
    transition: 'transform 0.15s ease-in-out',
    '&:hover': { transform: 'scale3d(1.05, 1.05, 1)', cursor: 'pointer' }
  },
  link: {
    display: 'block',
    margin: '0 10px'
  }
});

export default function ToolsCarousel(userObject) {
  const responsive = {
    largeDesktop: {
      breakpoint: { max: 4000, min: 2100 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 2100, min: 1700 },
      items: 4
    },
    smallDesktop: {
      breakpoint: { max: 1700, min: 1300 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1300, min: 800 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 800, min: 0 },
      items: 1
    }
  };
  const userClientId = userObject?.user?.clientId;
  const userId = localStorage.getItem('LOCELLE:USER');
  const classes = useStyles();
  const dispatch = useDispatch();
  const learningTools = useSelector(getLearningTools);
  const userGroups = useSelector(getUserGroups);

  useEffect(() => {
    dispatch(fetchLearningTools());
    dispatch(fetchUserGroups(userId));
  }, [userId]);

  // Get user's cohort IDs from their active groups only
  const userCohortIds = userGroups?.filter((group) => group.status === GroupStatus.Active)?.map((group) => group.id);

  const activeLearningTools = learningTools?.filter((lt) => lt.status === ResourceStatus.Active && lt.placement === ResourcePlacement?.ResourcesPage);
  const learningToolsWithRestrictions = activeLearningTools?.filter((lt) => {
    // Check client restrictions
    const clientMatch = lt.clientIds ? lt?.clientIds?.includes(userClientId) : true;
    
    // Check cohort restrictions
    const cohortMatch = lt.cohortIds && lt.cohortIds.length > 0 
      ? userCohortIds?.some(cohortId => lt.cohortIds.includes(cohortId))
      : true;
    
    return clientMatch && cohortMatch;
  });

  return (
    <Box sx={{ mr: '120px' }}>
      {!learningToolsWithRestrictions?.length && (
        <Typography sx={{ mb: '80px', mt: '60px', ml: 3, color: Colors.TextElevated, fontSize: '1.2rem' }}>
          New resources will be added soon
        </Typography>
      )}
      <Carousel
        containerClass="container"
        responsive={responsive}
        draggable={false}
        pauseOnHover={true}
      >
        {learningToolsWithRestrictions?.map((item) => (
          <a target="blank" rel="noreferrer" className={classes.link} style={{ textDecoration: 'none', color: 'black' }} href={item?.azureUrl}>
            <Card key={item?.id} className={classes.root}>
              <CardMedia sx={{ height: '180px' }} component="img" image={item?.thumbnailUrl} />
              <CardContent>
                <Typography textAlign="center" variant="h6" component="div" sx={{ color: Colors.TextElevated }}>
                  {item.title}
                </Typography>
              </CardContent>
            </Card>
          </a>
        ))}
      </Carousel>
    </Box>
  );
}